<template>
  <div>
    <div class="d-flex align-items-start">
      <b-avatar
        :src="getStorage(activity.user?.avatar)"
        :text="getInitials(activity.user?.name)"
        size="20"
        :variant="'light-primary'"
        :style="{ marginTop: '4px' }"
        class="mr-1"
      />
      <div>
        <div
          class="font-12"
          v-html="description || activity.description"
        />
        <small
          v-if="moment(activity.createdAt).isAfter(moment().subtract(1, 'day'))"
          class="text-secondary"
          :style="{ fontSize: '11px' }"
        >
          <!-- {{ FORMAT_DATE(activity.createdAt, "Do MMM YYYY") }} -->
          {{ moment(activity.createdAt).fromNow() }}
        </small>

        <small
          v-else
          class="text-secondary"
          :style="{ fontSize: '11px' }"
        >
          {{ moment(activity.createdAt).format('Do MMM YYYY') }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'
import moment from 'moment'

export default {
  components: {
    BAvatar,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    description: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      moment,
    }
  },
}
</script>
